'use client';

import { usePathname } from 'next/navigation';
import React, { useEffect } from 'react';
import { analyticsEvents } from '../../utils/analytics/analytics';
import { userAnalytics } from '../../utils/analytics/analytics-logging';

export const Analytics: React.FC = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    analyticsEvents.pageView(undefined, undefined, document.title);
  }, [pathname]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const searchParams = new URLSearchParams(window.location.search);
    userAnalytics.checkUserAnalyticsDataFromSearchParams(searchParams);
  }, []);

  return null;
};
